import { render, staticRenderFns } from "./com-jzx-empty.vue?vue&type=template&id=6622d4ba&scoped=true&"
import script from "./com-jzx-empty.vue?vue&type=script&lang=ts&"
export * from "./com-jzx-empty.vue?vue&type=script&lang=ts&"
import style0 from "./com-jzx-empty.vue?vue&type=style&index=0&id=6622d4ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6622d4ba",
  null
  
)

export default component.exports